const CATEGORY_ORDER = [
  'transcription',
  'audio',
  'media',
  'text',
  'data-extraction',
  'images-files',
  'productivity',
] as const;

const CATEGORY_LABEL_KEYS: Record<string, string> = {
  audio: 'com.streamlain.marketplace.browse.category.audio',
  'data-extraction':
    'com.streamlain.marketplace.browse.category.data-extraction',
  'images-files': 'com.streamlain.marketplace.browse.category.images-files',
  media: 'com.streamlain.marketplace.browse.category.media',
  productivity: 'com.streamlain.marketplace.browse.category.productivity',
  text: 'com.streamlain.marketplace.browse.category.text',
  transcription: 'com.streamlain.marketplace.browse.category.transcription',
};

type TranslationLookup = Record<string, unknown>;

function categoryOrderIndex(category: string): number {
  const index = CATEGORY_ORDER.indexOf(
    category as (typeof CATEGORY_ORDER)[number]
  );
  return index === -1 ? CATEGORY_ORDER.length : index;
}

function humanizeCategory(category: string): string {
  return category
    .split(/[-_]/g)
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function getMarketplaceCategoryLabel(
  i18n: TranslationLookup,
  category: string
): string {
  const key = CATEGORY_LABEL_KEYS[category];
  const translation = key ? i18n[key] : undefined;
  return typeof translation === 'function'
    ? (translation as () => string)()
    : humanizeCategory(category);
}

export function compareMarketplaceCategories(a: string, b: string): number {
  const orderDelta = categoryOrderIndex(a) - categoryOrderIndex(b);
  return orderDelta !== 0
    ? orderDelta
    : humanizeCategory(a).localeCompare(humanizeCategory(b));
}
